import { useQuery } from "@tanstack/react-query";
import { getHeadersWithUniqueVisitorId } from "../../Auth/index.js";
const fetchConversationStarters = async (stacklineSku, axios, apiBaseUrl) => {
  var _a;
  if (axios) {
    const response = await axios.post("/concierge/conversationStarters", {
      stacklineSku
    });
    return ((_a = response.data) == null ? void 0 : _a.questions) || [];
  } else if (apiBaseUrl) {
    const response = await fetch(`${apiBaseUrl}/concierge/conversationStarters`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ stacklineSku })
    });
    if (response.ok) {
      const data = await response.json();
      return (data == null ? void 0 : data.questions) || [];
    }
    return [];
  } else {
    const headers = await getHeadersWithUniqueVisitorId();
    const response = await fetch(`/api-rewards/concierge/conversationStarters`, {
      method: "POST",
      headers: {
        ...headers,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ stacklineSku })
    });
    if (response.ok) {
      const data = await response.json();
      return (data == null ? void 0 : data.questions) || [];
    }
    return [];
  }
};
const useConversationStarters = ({
  stacklineSku,
  axios,
  apiBaseUrl,
  enabled = true
}) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["conversationStarters", stacklineSku, apiBaseUrl],
    queryFn: () => fetchConversationStarters(stacklineSku, axios, apiBaseUrl),
    enabled: enabled && !!stacklineSku,
    staleTime: 5 * 60 * 1e3,
    // Cache for 5 minutes
    gcTime: 10 * 60 * 1e3
    // Keep in cache for 10 minutes
  });
  return {
    questions: data || [],
    isLoading,
    error
  };
};
export {
  useConversationStarters
};
//# sourceMappingURL=useConversationStarters.js.map
